/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamVerificationDetailSubmittedPiiAddress } from './PamVerificationDetailSubmittedPiiAddress';
import {
    PamVerificationDetailSubmittedPiiAddressFromJSON,
    PamVerificationDetailSubmittedPiiAddressFromJSONTyped,
    PamVerificationDetailSubmittedPiiAddressToJSON,
} from './PamVerificationDetailSubmittedPiiAddress';

/**
 * 
 * @export
 * @interface PamVerificationDetailSubmittedPii
 */
export interface PamVerificationDetailSubmittedPii {
    /**
     * 
     * @type {PamVerificationDetailSubmittedPiiAddress}
     * @memberof PamVerificationDetailSubmittedPii
     */
    address: PamVerificationDetailSubmittedPiiAddress;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetailSubmittedPii
     */
    ssn4?: string;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetailSubmittedPii
     */
    dob: string;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetailSubmittedPii
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetailSubmittedPii
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationDetailSubmittedPii
     */
    firstName: string;
}

/**
 * Check if a given object implements the PamVerificationDetailSubmittedPii interface.
 */
export function instanceOfPamVerificationDetailSubmittedPii(value: object): value is PamVerificationDetailSubmittedPii {
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('dob' in value) || value['dob'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    return true;
}

export function PamVerificationDetailSubmittedPiiFromJSON(json: any): PamVerificationDetailSubmittedPii {
    return PamVerificationDetailSubmittedPiiFromJSONTyped(json, false);
}

export function PamVerificationDetailSubmittedPiiFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamVerificationDetailSubmittedPii {
    if (json == null) {
        return json;
    }
    return {
        
        'address': PamVerificationDetailSubmittedPiiAddressFromJSON(json['address']),
        'ssn4': json['ssn4'] == null ? undefined : json['ssn4'],
        'dob': json['dob'],
        'phone': json['phone'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
    };
}

export function PamVerificationDetailSubmittedPiiToJSON(value?: PamVerificationDetailSubmittedPii | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'address': PamVerificationDetailSubmittedPiiAddressToJSON(value['address']),
        'ssn4': value['ssn4'],
        'dob': value['dob'],
        'phone': value['phone'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
    };
}

